import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'

import PageTitle from './PageTitle'
import SearchBox from './SearchBox'
import Tabs from './Tabs'


import Styles from './index.scss'

const List = (props) => {
  const {
    tab,
    handleChangeTab,
    qs,
    handleDirectToPaymentNeeded,
  } = props

  return (
    <div className="page-content">
      {props.isLoading && (<Loading />)}
      <Breadcrumb data={props} />
      <div className="row">
        <PageTitle />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="portlet light portlet-fit">
            <div className="portlet-title" style={{ borderBottom: '1px solid #dfdfdf', height: '63px' }}>
              {/* Tab sections */}
              <div className={Styles.tabContainer}>
                <button onClick={() => handleChangeTab(0, qs)} className={Styles.tabButton}>
                  <span style={{ color: tab === 0 ? '#ee5e4b' : '#9b9b9b' }} className={Styles.tabTitle} >INVOICES</span>
                  <hr style={{ opacity: tab === 0 ? '1' : '0' }} className={Styles.line} />
                </button>
                <Link onClick={() => handleDirectToPaymentNeeded()} className={Styles.paymentNeeded} to={'/projects'}>
                  Need Approval
                </Link>
              </div>
              {/* ---- */}
            </div>
            <SearchBox />
            <Tabs tab={tab} />
          </div>
        </div>
      </div>
    </div>
  )
}

List.propTypes = {
  tab: PropTypes.number.isRequired,
  handleChangeTab: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  qs: PropTypes.shape({}).isRequired,
  handleDirectToPaymentNeeded: PropTypes.func.isRequired,
}

export default List
